import { createSelector } from 'reselect';

const selectRolePermissions = (state) => state.permissions.rolePermissions;

export const makeSelectUserPermissions = () =>
  createSelector([selectRolePermissions], (rolePermissions) => ({ userPermissions: rolePermissions }));
